import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { authorizeCheck, ciscoAuthDigiPass, setUserName } from "./Oauth";

const AuthRecieverDigiPass = () => {
  const [authorized, setAuthorized] = useState(false);

  const authorize = async () => {
      const [check, user] = await authorizeCheck(ciscoAuthDigiPass);

      if (check) {
        setUserName(user);
        setAuthorized(true);
      }
  
    };

  useEffect(() => {
    authorize();
  }, []);

  return authorized ? <Redirect to="/digipass" /> : <></>;
};

export default AuthRecieverDigiPass;
